import reviews from "../../repo/reviews";

import template from "./yourreview.tpl";
import './yourreview.css';
import Review from "./review";

export default DomClass(template, function YourReview() {
	const _t = this;

	let initial_rating = this.rating;
	Object.defineProperty(this, 'rating', {
		get: function() {
			return this.stars.options[this.stars.selectedIndex].value
		},
		set: function(value) {
			for (let i = 0; i < this.stars.options.length; i++) {
				if (this.stars.options[i].value == value) {
					this.stars.selectedIndex = i;
				}
			}
		}
	});
	if (initial_rating) {
		this.rating = initial_rating;
	}

	this.load = function(reviewDetails) {
		this.review = new Review({
			...reviewDetails,
			owner: "<b>(Your Review - Click to add/edit)</b>"
		});
		this.review.onclick = function() {
			_t.className = 'editing';
		};
		this.className = '';
	};

	this.submitButton.onclick = function() {
		reviews.put({
			id: _t.id,
			diseaseNormalizedName: _t.diseaseNormalizedName,
			rating: Number.parseInt(_t.rating),
			comment: _t.comment
		}).then((review) => _t.load(review))
		.catch(() => alert('Oops! Try saving your review again later!'));
	};

	this.load(this);

});
